import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const communicationsStatusPageCreateRoute: InvariantJiraRoute = {
	name: 'communications-status-page-create',
	path: '/jira/communications/status-page/create',
};
